import React from 'react';

export interface PendingFilesProps {
  width?: string;
  height?: string;
}

const PendingFiles: React.FC<PendingFilesProps> = (props): JSX.Element => {
  /* istanbul ignore next */
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81"
      height="66.621"
      viewBox="0 0 81 66.621"
    >
      <g transform="translate(-523.5 -567.5)">
        <path
          fill="#fff"
          d="M130.332,204.718a7.6,7.6,0,0,0-7.307-5.916c-2.082-.042-4.166-.028-6.249,0a1.5,1.5,0,0,1-1.214-.523,17.975,17.975,0,0,0-11.745-5.677A18.551,18.551,0,0,0,88.4,198.3a1.789,1.789,0,0,1-1.132.467c-2.265.043-4.53.021-6.8.021h-2.34c0-.385.007-.689,0-.992-.042-1.508.007-3.025-.15-4.521a7.65,7.65,0,0,0-7.587-6.8q-6.054-.016-12.107.009a7.8,7.8,0,0,0-1.924.244,8.067,8.067,0,0,0-5.84,7.708c-.027,5.546-.009,31.225-.01,36.771,0,.06,0,.12,0,.18q0,6.632.005,13.264a7.024,7.024,0,0,0,1.467,4.279,7.532,7.532,0,0,0,6.31,3.153q13.045.014,26.089,0c12.706,0,25.413.021,38.119-.021a7.717,7.717,0,0,0,7.335-4.785,15.951,15.951,0,0,0,.668-2.064v-40A4.717,4.717,0,0,1,130.332,204.718Z"
          transform="translate(473.492 381.536)"
        />
        <g transform="translate(473.492 381.536)">
          <path
            fill="#384164"
            stroke="rgba(0,0,0,0)"
            strokeMiterlimit="10"
            d="M20.781,2280.083q-5.2,0-10.4,0-13.044,0-26.089,0a7.535,7.535,0,0,1-6.31-3.154,7.024,7.024,0,0,1-1.468-4.279q-.011-6.632-.005-13.264v-.18c0-5.546-.017-31.225.01-36.771a8.067,8.067,0,0,1,5.84-7.708,7.83,7.83,0,0,1,1.923-.244q6.053-.033,12.108-.008a7.648,7.648,0,0,1,7.587,6.8c.158,1.5.109,3.013.15,4.521.008.3,0,.608,0,.993H6.473c2.265,0,4.531.022,6.8-.021a1.789,1.789,0,0,0,1.132-.467,18.548,18.548,0,0,1,15.417-5.7,17.973,17.973,0,0,1,11.745,5.677,1.5,1.5,0,0,0,1.214.523c2.083-.024,4.166-.039,6.249,0a7.6,7.6,0,0,1,7.307,5.916,4.705,4.705,0,0,0,.175.492v40a15.929,15.929,0,0,1-.668,2.064,7.715,7.715,0,0,1-7.335,4.784q-9.365.031-18.729.026Zm27.311-3.154a4.9,4.9,0,0,0,5.287-5.248q.005-18.434,0-36.869a4.548,4.548,0,0,0-4.871-4.883c-1.344,0-2.687,0-4.14,0a18.946,18.946,0,0,1,1.6,15.088,18.235,18.235,0,0,1-6.909,9.578,18.8,18.8,0,0,1-22.163-.062,18.406,18.406,0,0,1-7.286-11.27,19,19,0,0,1,2.054-13.342H7.522c-1.562,0-3.124,0-4.686,0-1.269,0-1.879-.581-1.895-1.846-.021-1.718.064-3.441-.033-5.154a8.264,8.264,0,0,0-.624-2.851,3.942,3.942,0,0,0-3.776-2.443c-4.087-.03-8.176-.041-12.263,0-2.673.029-4.59,2.248-4.6,5.277-.017,4.433-.009,22.887-.008,31.96,0,.046.005.092.005.139q.005,8.552,0,17.106a4.514,4.514,0,0,0,3.253,4.605,6,6,0,0,0,1.617.205q28.783.011,57.569,0C44.082,2276.923,46.087,2276.933,48.092,2276.929ZM28.039,2223.67a15.643,15.643,0,1,0,.035,0Zm-12.923,15.825a12.793,12.793,0,1,1,12.741,12.729A12.765,12.765,0,0,1,15.116,2239.494Zm3.232-.4a9.538,9.538,0,1,0,9.577-9.192h-.067A9.552,9.552,0,0,0,18.347,2239.1Z"
            transform="translate(74 -2028)"
          />
          <path
            fill="#2890c1"
            d="M371.075,313.433c1.543.017,3.087.015,4.63,0a1.631,1.631,0,0,0,1.807-1.6,1.679,1.679,0,0,0-1.81-1.614c-1.008-.012-2.016,0-3.139,0,0-1.054.014-2.007,0-2.96a1.686,1.686,0,0,0-1.626-1.812,1.63,1.63,0,0,0-1.621,1.719c-.037,1.516-.044,3.034,0,4.55A1.569,1.569,0,0,0,371.075,313.433Z"
            transform="translate(-269.001 -100.418)"
          />
        </g>
      </g>
    </svg>
  );
};
export default PendingFiles;
